<template>

	<div id="app">


	</div>
</template>

<script>
	export default {
		name: "hellow",
		data() {
			return {
				isload: false,
			}
		},
		created() {

		},
		methods: {

		}
	};
</script>

<style >
	
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue